import styled from 'styled-components';
import { fontSize, screen } from 'theme';

const Root = styled.div`
  background-color: #faf9ff;
  color: #433f52;
  padding: 24px 1rem;
  font-size: ${fontSize('lg')};
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media (min-width: ${screen('lg')}) {
    padding: 64px 0;
  }

  .intro {
    margin-bottom: 2rem;

    @media (min-width: ${screen('lg')}) {
      max-width: 70%;
      margin-left: auto;
      margin-right: auto;

      &.full {
        max-width: 100%;
      }
    }
  }
`;

const CardContent1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  line-height: 1.75;
  font-size: ${fontSize('md')};

  h3 {
    font-size: ${fontSize('lg')};
    line-height: 1.25;
    margin-bottom: 0;
  }

  img {
    max-width: 100%;
    margin: 0 auto;
  }

  p {
    margin-bottom: 0.75rem;
    line-height: 1.5;
  }

  ul {
    margin: 0 0 1.5rem 0;
  }

  li {
    background: url(/images/companies-new/companies-new-bullet.svg) no-repeat 0
      0.35rem;
    padding-left: 1.75rem;
    margin-bottom: 0.25rem;
  }

  &.no-list-style li {
    padding-left: 0;
    background: none;
    list-style-type: disc;
    margin-left: 1.5rem;
  }

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    align-items: center;
    gap: 4rem;
    font-size: ${fontSize('lg')};

    h3 {
      font-size: ${fontSize('xl3')};
    }

    img {
      max-width: 40%;
    }
  }
`;

export const TalentCVStyles = {
  Root,
  CardContent1
};
